import { Typography } from "@mui/material";
import AurPieChart from "../../../common/aur-piechart/AurPieChart";

  const data3 = [
    { value: 4.2, label: 'Data in ECA & NLP Indexes', },
    { value: 14.3, label: 'Storage in Relativity', onClick:() => alert('clicked')},
    { value: 22.7, label: 'Expanded in Processing' },
  ];

  const data4 = [
    { value: 4.2, label: 'Data in ECA & NLP Indexes', },
    { value: 14.3, label: 'Storage in Relativity' },
    { value: 22.7, label: 'Expanded in Processing', onClick:() => alert('clicked') },
    { value: 15.2, label: 'Compressed Data Received at Intake'},
  ];

  const data5 = [
    { value: 4.2, label: 'Data in ECA & NLP Indexes', onClick:() => alert('clicked')},
    { value: 7.3, label: 'Storage in Relativity'},
    { value: 12.7, label: 'Expanded in Processing' },
    { value: 6.2, label: 'Compressed Data Received at Intake'},
    { value: 8.4, label: 'Some Other Value', onClick: () => alert('clicked')}
  ];
  
  const size = {
    width: 650,
    height: 400,
  };

  const PieChart = () => {
    return (
    <>
    <Typography>3 Segments</Typography>
    <AurPieChart 
        data={data3} 
        size={size} 
        radius={138} 
        innerRadius={80} 
        labelPadding={20} 
        centerText={
        <>
            <tspan>{data3.reduce(((total: number, item) => total + item.value),0).toFixed(1)}</tspan>
            <tspan className="aur-pie-chart-center-sublabel" dy={'4px'}> GB</tspan>
        </>} />
    <Typography>4 Segments</Typography>
    <AurPieChart 
        data={data4} 
        size={size} 
        radius={138} 
        innerRadius={80} 
        labelPadding={20} 
        centerText={
        <>
            <tspan>{data4.reduce(((total: number, item) => total + item.value),0).toFixed(1)}</tspan>
            <tspan className="aur-pie-chart-center-sublabel" dy={'4px'}> GB</tspan>
        </>} />
        <Typography>5 Segments</Typography>
    <AurPieChart 
        data={data5} 
        size={size} 
        radius={138} 
        innerRadius={80} 
        labelPadding={20} 
        centerText={
        <>
            <tspan>{data5.reduce(((total: number, item) => total + item.value),0).toFixed(1)}</tspan>
            <tspan className="aur-pie-chart-center-sublabel" dy={'4px'}> GB</tspan>
        </>} />
    </>
    )
  }

  export default PieChart;






